import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://api.forestdigitalservices.com/api',
    // baseURL: 'http://localhost:4000/api',
    withCredentials: true
})

export default instance